import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@cordata/buffet';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';

import {
  authorizedPyPublicInstance as Py,
} from '~/utils';

import { PseudoStates } from '~/components';

const NoteCell = ({ original, params }) => {
  const { attributes: { hasNotes, sacwisId, patenccsnid } } = original;

  const [data, setData] = useState();
  const [status, setStatus] = useState('loading');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () =>
    setIsModalOpen(p => !p);

  useEffect(() => {
    setStatus('loading');
    setData();

    if (hasNotes && isModalOpen) {
      Py
        .get('/list-view-cs-tbl-notes', {
          params: {
            ...params,
            sacwisId,
            patenccsnid,
          },
        })
        .then(r => r.data.data)
        .then(r => {
          setData(r);
          setStatus('success');
        })
        .catch(() => setStatus('error'));
    }
  }, [hasNotes, isModalOpen]);

  return hasNotes
    ? (
      <>
        <Button
          color="link"
          type="button"
          className="p-0"
          outline
          onClick={toggleModal}
        >
          Click to view
        </Button>

        <Modal isOpen={isModalOpen} toggle={toggleModal} size="lg">
          <ModalHeader toggle={toggleModal}>Notes</ModalHeader>

          <ModalBody>
            {status === 'success'
              ? data.map(d => (
                <>
                  <h4>{d.attributes.notetype}</h4>

                  <pre style={{ whiteSpace: 'break-spaces' }}>{d.attributes.notetext}</pre>

                  <hr />
                </>
              ))
              : <PseudoStates mini status={status} />
            }
          </ModalBody>

          <ModalFooter>
            <Button type="cancel" color="tertiary" outline onClick={toggleModal}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </>
    ) : null;
};

NoteCell.propTypes = {
  original: PropTypes.shape().isRequired,
  params: PropTypes.shape(),
};

NoteCell.defaultProps = {
  params: {},
};

export default NoteCell;
